module.exports = __webpack_public_path__ + "static/img/200115.99a231c3.png";